// CSS class prefix
const carouselClass = ".timeline-carousel__";

/**
 * Initialization of the Timeline Carousel
 *
 * @param {jQuery} $carousel Carousel element
 * @param {jQuery} $carouselIntro Carousel intro section
 */
const carouselInitialization = ($carousel, $carouselIntro) => {
    const endSlide = $(`${carouselClass}slide`, $carousel).length - 1;
    let lastSeenSlide = 0;

    // On the initialization we are getting the data-title for each slide and put in the slick navigation
    $carousel.on("init", () => {
        const $slickDots = $(".slick-dots", $carousel);

        $("li", $slickDots).each((index, $dot) => {
            const $slide = $(`.slick-slide[data-slick-index="${index}"]`);
            const slideTitle = $(`${carouselClass}slide`, $slide).attr("data-title");
            $("button", $dot).text(slideTitle);
        });

        // If $carouselIntro is provided we clone the navigation and append it to intro section
        // in order to be shown before clicking on the Start CTA
        // Otherwise we add a click event listener for the real navigation of the carousel
        if ($carouselIntro && $carouselIntro.length) {
            const $clonedDots = $slickDots.clone();
            $carouselIntro.append($clonedDots);
        } else {
            $slickDots.on("click", () => {
                $slickDots.toggleClass("expanded");
            });
        }
    });

    // If $carouselIntro is not provided, means that the carousel should be initialized and
    // we need to setup the animation for the slides
    if (!$carouselIntro) {
        $carousel.on("afterChange", (event, slick, currentSlide) => {
            // if the slides are consecutive then we add animation
            // otherwise slide will be showed without animation
            const firstToEndSlide = lastSeenSlide === 0 && currentSlide === endSlide;
            const endToFirstSlide = lastSeenSlide === endSlide && currentSlide === 0;
            const useAnimation = firstToEndSlide || endToFirstSlide || [-1, 1].includes(parseInt(currentSlide - lastSeenSlide, 10));
            const animationClass = currentSlide > lastSeenSlide ? "in" : "in-reverse";
            const slideClass = useAnimation ? animationClass : "drop";

            setTimeout(() => {
                $(".slick-slide", $carousel).removeClass("in in-reverse out out-reverse drop");
                $(slick.$slides[currentSlide]).addClass(slideClass);

                lastSeenSlide = currentSlide;
                $(".slick-dots li, .slick-arrow", $carousel).removeClass("disabled");
            }, (useAnimation ? 900 : 0));
        });

        $carousel.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
            // if the slides are consecutive then we add animation
            // otherwise slide will slide out without animation
            $(".slick-slide", $carousel).removeClass("in in-reverse out out-reverse drop");
            $(".slick-dots li, .slick-arrow", $carousel).addClass("disabled");

            const firstToEndSlide = currentSlide === 0 && nextSlide === endSlide;
            const endToFirstSlide = currentSlide === endSlide && nextSlide === 0;
            const useAnimation = firstToEndSlide || endToFirstSlide || [-1, 1].includes(parseInt(currentSlide - nextSlide, 10));
            const animationClass = currentSlide < nextSlide ? "out" : "out-reverse";
            const slideClass = useAnimation ? animationClass : "drop";

            $(slick.$slides[currentSlide]).addClass(slideClass);
        });
    }

    // Carousel options
    $carousel.slick({
        autoplay: false,
        mobileFirst: true,
        arrows: true,
        slidesToShow: 1,
        dots: true,
        infinite: true,
        fade: true,
        cssEase: "linear",
        speed: 0
    });
};

export default () => {
    const $timelineCarouselWrapper = $(".js-timeline-carousel");

    $timelineCarouselWrapper.each(($carouselWrapper) => {
        const $startBtn = $(`${carouselClass}start-button`, $carouselWrapper);
        const $carouselIntro = $(`${carouselClass}intro`, $carouselWrapper);
        const $carousel = $(`${carouselClass}carousel`, $carouselWrapper);

        if ($carousel.length) {
            carouselInitialization($carousel, $carouselIntro);
            $carousel.slick("unslick");
        }

        $startBtn.on("click", () => {
            $carouselIntro.addClass("getting-out");

            setTimeout(() => {
                $carouselIntro.remove();
                carouselInitialization($carousel);
                $(".slick-slide[data-slick-index=0]", $carousel).addClass("in");
            }, 1000);
        });
    });
};
